import { gql } from '@apollo/client/core/index.js'

export const mutations = {
  UPSERT_BUDGETS_BY_CAMPAIGN_GROUP_ID: gql`
    mutation SELECT_UpsertBudgetsByCampaignGroupId(
      $update: BudgetUpdateInput!
      $is_save: Boolean
    ) {
      upsertBudgetsByCampaignGroupId(update: $update, is_save: $is_save) {
        flight_id
        campaign_group_id
        budget
        budget_type_id
        start_time
        end_time
      }
    }
  `,
  REPRICE_IMPRESSION_CAPS: gql`
    mutation SELECT_RepriceImpressionCaps($input: RepriceImpressionCapsInput!) {
      repriceImpressionCaps(input: $input) {
        flight_id
        campaign_group_id
        budget
        impression_cap
      }
    }
  `,
}
